import { Router } from '@angular/router';
import { TokenStorage } from '../../core/token.storage';
import { Injectable } from '@angular/core';


@Injectable()
export class CheckTokenService {
    
    constructor(private token: TokenStorage, private router: Router){}

    verifyToken() {

        // Get current url.
        //let url =  window.location.href;

        if (this.token.getToken() == null) {
           
            this.router.navigate(['login']); 
           
        }
        /*else{
            if (this.token.getUserProfile() === 'CLIENT'){
                this.router.navigate(['main']); 

            }
            else{
                this.router.navigate(['admin/statistique']); 
            }
        }*/
        //return false;
       
    }

}



// WEBPACK FOOTER //
// ./src/app/common/services/check-token.service.ts